export const EditPassword = 'EditPassword'
export const EditEmail = 'EditEmail'
